export const es = {
    nav: {
        dashboard: 'Panel de control',
        board: 'Tablero',
        list: 'Lista',
        settings: 'Configuración',
        reports: 'Informes',
        myTasks: 'Mis tareas',
        activity: 'Actividad',
        charts: 'Gráficos',
        team: 'Equipo',
        timeTracking: 'Seguimiento de tiempo',
        admin: 'Administrador',
        adminOverview: 'Resumen administrativo',
        userManagement: 'Gestión de usuarios',
        projectSetup: 'Configuración de proyectos',
    },
    common: {
        projectManMD: 'ProjectManMD',
        markdownProjectManagement: 'Gestión de proyectos en Markdown',
        version: 'Versión',
        back: 'Atrás',
        loading: 'Cargando...',
        noData: 'Sin datos',
        search: 'Buscar',
        filter: 'Filtrar',
        all: 'Todos',
        close: 'Cerrar',
        open: 'Abrir',
        connect: 'Conectar',
        archived: 'Archivado',
        inactive: 'Inactivo',
        active: 'Activo',
        untitled: 'Sin título',
        unknown: 'Desconocido',
        tasks: 'Tareas',
        done: 'Hecho',
        lastModified: 'Última modificación',
        created: 'Creado',
        points: 'Puntos',
        pts: 'pts',
        yes: 'Sí',
        no: 'No',
        or: 'o',
    },
    actions: {
        create: 'Crear',
        edit: 'Editar',
        delete: 'Eliminar',
        save: 'Guardar',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        add: 'Agregar',
        remove: 'Eliminar',
        update: 'Actualizar',
        close: 'Cerrar',
        submit: 'Enviar',
        reset: 'Restablecer',
        load: 'Cargar',
        export: 'Exportar',
        import: 'Importar',
        archive: 'Archivar',
        restore: 'Restaurar',
        deactivate: 'Desactivar',
        activate: 'Activar',
    },
    auth: {
        signIn: 'Iniciar sesión',
        signOut: 'Cerrar sesión',
        signUp: 'Registrarse',
        username: 'Nombre de usuario',
        password: 'Contraseña',
        confirmPassword: 'Confirmar contraseña',
        displayName: 'Nombre visible',
        email: 'Correo',
        role: 'Rol',
        createAccount: 'Crear cuenta',
        dontHaveAccount: '¿No tienes una cuenta?',
        alreadyHaveAccount: '¿Ya tienes una cuenta?',
        signInToAccount: 'Inicia sesión en tu cuenta',
        createYourAccount: 'Crea tu cuenta',
        enterUsername: 'Ingresa tu nombre de usuario',
        enterPassword: 'Ingresa tu contraseña',
        chooseUsername: 'Elige un nombre de usuario',
        yourFullName: 'Tu nombre completo',
        atLeast6Chars: 'Al menos 6 caracteres',
        confirmPasswordPlaceholder: 'Confirma tu contraseña',
        pleaseEnterCredentials: 'Por favor ingresa nombre de usuario y contraseña',
        invalidCredentials: 'Nombre de usuario o contraseña inválidos',
        pleaseFillAllFields: 'Por favor completa todos los campos',
        passwordsDoNotMatch: 'Las contraseñas no coinciden',
        passwordTooShort: 'La contraseña debe tener al menos 6 caracteres',
        usernameExists: 'El nombre de usuario ya existe',
        demoCredentials: 'Credenciales de demostración',
        admin: 'Administrador',
        manager: 'Gerente',
        developer: 'Desarrollador',
        viewer: 'Espectador',
        contactAdminForRole: 'Contacta al administrador para cambiar el rol',
        usernameCannotBeChanged: 'El nombre de usuario no se puede cambiar',
    },
    statuses: {
        backlog: 'Pendientes',
        todo: 'Por hacer',
        inProgress: 'En progreso',
        inReview: 'En revisión',
        done: 'Completado',
        planned: 'Planificado',
        inProgressSprint: 'En progreso (Sprint)',
        completed: 'Completado',
        allStatus: 'Todos los estados',
    },
    priorities: {
        critical: 'Crítico',
        high: 'Alto',
        medium: 'Medio',
        low: 'Bajo',
    },
    messages: {
        noProjects: 'Aún no hay proyectos',
        noTasks: 'No hay tareas',
        confirmDelete: '¿Está seguro de que desea eliminar esto?',
        saved: 'Guardado exitosamente',
        error: 'Ocurrió un error',
        noTasksAssigned: 'No hay tareas asignadas a ti',
        noActivityYet: 'Sin actividad aún',
        confirmReset: 'Esto restablecerá todos los datos al estado de ejemplo. ¿Continuar?',
        removeUserConfirm: '¿Está seguro de que desea eliminar a este usuario?',
        deleteProjectConfirm: '¿Está seguro de que desea eliminar este proyecto?',
        archiveProjectConfirm: '¿Está seguro de que desea archivar este proyecto?',
    },
    settings: {
        title: 'Configuración',
        theme: 'Tema',
        language: 'Idioma',
        languageAndRegion: 'Idioma y región',
        gitConfig: 'Configuración de Git',
        gitIntegration: 'Integración de Git',
        gitProvider: 'Proveedor de Git',
        repositoryUrl: 'URL del repositorio',
        seedData: 'Datos de ejemplo',
        seedDataDescription: 'Carga proyectos de ejemplo con tareas, sprints y épicas para pruebas.',
        loadSeedData: 'Cargar datos de ejemplo',
        seedDataConfirm: 'Esto restablecerá todos los datos al estado de ejemplo. ¿Continuar?',
        appearance: 'Apariencia',
        notifications: 'Notificaciones',
    },
    themes: {
        summer: 'Verano',
        spring: 'Primavera',
        autumn: 'Otoño',
        winter: 'Invierno',
        day: 'Día',
        night: 'Noche',
        summerDay: 'Día de verano',
        summerNight: 'Noche de verano',
        springDay: 'Día de primavera',
        springNight: 'Noche de primavera',
        autumnDay: 'Día de otoño',
        autumnNight: 'Noche de otoño',
        winterDay: 'Día de invierno',
        winterNight: 'Noche de invierno',
        highContrast: 'Alto contraste',
        selectTheme: 'Seleccionar tema',
    },
    time: {
        hours: 'horas',
        minutes: 'minutos',
        days: 'días',
        weeks: 'semanas',
        justNow: 'ahora mismo',
        minutesAgo: 'hace {{count}}m',
        hoursAgo: 'hace {{count}}h',
        daysAgo: 'hace {{count}}d',
        updatedAt: 'Actualizado',
    },
    reports: {
        velocity: 'Velocidad',
        burndown: 'Burndown',
        burnup: 'Burnup',
        cycleTime: 'Tiempo de ciclo',
        leadTime: 'Tiempo de entrega',
        throughput: 'Rendimiento',
        gantt: 'Gantt',
        cumulativeFlow: 'Flujo acumulativo',
    },
    globalSearch: {
        placeholder: 'Buscar proyectos, tareas, sprints...',
        noResults: 'No se encontraron resultados',
        projects: 'Proyectos',
        tasks: 'Tareas',
        sprints: 'Sprints',
        epics: 'Épicas',
    },
    notifications: {
        title: 'Notificaciones',
        markAllRead: 'Marcar todo como leído',
        clearAll: 'Borrar todo',
        empty: 'Sin notificaciones',
        unread: '{count} sin leer',
    },
    dashboard: {
        totalProjects: 'Total de proyectos',
        totalTasks: 'Total de tareas',
        completion: 'Finalización',
        statusBreakdown: 'Desglose por estado',
        createProject: 'Crear proyecto',
        loadSeedData: 'Cargar datos de ejemplo',
        noProjects: 'Aún no hay proyectos',
        getStarted: 'Comience creando un nuevo proyecto o cargando datos de ejemplo.',
        projects: 'Proyectos',
        newProject: 'Nuevo proyecto',
        createNewProject: 'Crear nuevo proyecto',
        projectName: 'Nombre del proyecto',
        description: 'Descripción',
        workflow: 'Flujo de trabajo',
        skipToMain: 'Saltar al contenido principal',
        projectProgress: 'Progreso del proyecto',
        quickActions: 'Quick Actions',
        manageTasks: 'Manage tasks and track progress',
        trackTime: 'Track time for your tasks',
    },
    calendar: {
        jalali: 'Jalali',
        hijri: 'Hégira',
        gregorian: 'Gregoriano',
    },
    accessibility: {
        skipToMain: 'Saltar al contenido principal',
        board: 'Tablero de tareas',
        projectList: 'Lista de proyectos',
        mainNav: 'Navegación principal',
        selectTheme: 'Seleccionar tema',
        projectDashboard: 'Panel de proyectos',
        toggleSidebar: 'Toggle sidebar',
    },
    board: {
        title: 'Tablero',
        kanban: 'Kanban',
        scrum: 'Scrum',
    },
    task: {
        title: 'Tarea',
        createTask: 'Crear tarea',
        editTask: 'Editar tarea',
        deleteTask: 'Eliminar tarea',
        assignee: 'Asignado a',
        unassigned: 'Sin asignar',
        storyPoints: 'Puntos de historia',
        labels: 'Etiquetas',
        description: 'Descripción',
        acceptanceCriteria: 'Criterios de aceptación',
        timeLog: 'Registro de tiempo',
        comments: 'Comentarios',
        addComment: 'Agregar comentario',
        noComments: 'Sin comentarios aún',
        status: 'Estado',
        priority: 'Prioridad',
        created: 'Creado',
        updated: 'Actualizado',
        started: 'Iniciado',
    },
    sprint: {
        title: 'Sprint',
        createSprint: 'Crear sprint',
        sprintGoal: 'Objetivo del sprint',
        committedPoints: 'Puntos comprometidos',
        completedPoints: 'Puntos completados',
        velocity: 'Velocidad',
        planned: 'Planificado',
        inProgress: 'En progreso',
        completed: 'Completado',
    },
    team: {
        title: 'Equipo',
        members: 'Miembros',
        role: 'Rol',
        availability: 'Disponibilidad',
        assignedTasks: 'Tareas asignadas',
        activeTasks: 'Tareas activas',
        doneTasks: 'Tareas completadas',
    },
    timeTracking: {
        title: 'Seguimiento de tiempo',
        timer: 'Temporizador',
        manualEntry: 'Entrada manual',
        startTime: 'Hora de inicio',
        stopTime: 'Hora de fin',
        duration: 'Duración',
        date: 'Fecha',
        totalHours: 'Horas totales',
        entries: 'Entradas',
        noEntries: 'Sin entradas aún',
        hours: 'Hours',
        minutes: 'Minutes',
    },
    admin: {
        dashboard: 'Panel administrativo',
        projects: 'Proyectos',
        totalTasks: 'Total de tareas',
        storyPoints: 'Puntos de historia',
        taskStatusBreakdown: 'Desglose de estado de tareas',
        projectProgress: 'Progreso del proyecto',
        teamWorkload: 'Carga de trabajo del equipo',
        assigned: 'Asignado',
        active: 'Activo',
    },
    myTasks: {
        title: 'Mis tareas',
        total: 'Total',
        inProgress: 'En progreso',
        inReview: 'En revisión',
        done: 'Hecho',
        completion: 'Finalización',
        allStatus: 'Todos los estados',
        allProjects: 'Todos los proyectos',
        noTasksAssigned: 'No hay tareas asignadas a ti',
    },
    activity: {
        title: 'Feed de actividad',
        commentsOnYourTasks: 'Comentarios en tus tareas',
        allActivity: 'Toda la actividad',
        noActivityYet: 'Sin actividad aún',
        commentedOn: 'comentó en',
        movedTo: 'movió a',
    },
    profile: {
        title: 'Perfil',
        avatar: 'Avatar',
        dragDropImage: 'Arrastra y suelta una imagen aquí, o navega por archivos',
        browse: 'Navegar',
        imageFormats: 'PNG, JPG, WEBP hasta 2 MB',
        removePhoto: 'Eliminar foto',
        saveChanges: 'Guardar cambios',
        profileSaved: 'Perfil guardado',
        contactAdmin: 'Contacta al administrador para cambios de rol',
    },
};
//# sourceMappingURL=es.js.map